import { connect } from 'react-redux';

import PdfSection from './pdf.jsx';

import {
  getRenderAsMobile,
  getAssetForContent,
  getSectionSingletonContentItem
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  setOverlayContentUuid
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';

import userAgentDetect from 'zoomforth_zfutils/useragent_detect.js';

import {
  canViewPDF
} from 'zoomforth_zfutils/browser_pdf_support.js';

import {
  getHeightStyle
} from 'zoomforth_codesbane_viewer/lib/sections.js';

export const mapStateToProps = (state, { section }) => {
  const isMobile = getRenderAsMobile(state) || 
    userAgentDetect.isMobile.isAnyRealDevice(); // TODO: Stop using inAnyRealDevice to detect mobileness

  const contentItem = getSectionSingletonContentItem(state, section);
  const asset = getAssetForContent(state, contentItem);
  const height = getHeightStyle(section);

  return {
    height,
    isMobile,
    asset,
    contentItem,
    canEmbedPdf: canViewPDF(),
    id: section.id,
    type: section.type
  };
};

export const mapDispatchToProps = (dispatch) => ({
  onNoEmbedPdfSectionClick: (contentUuid) => {
    dispatch(setOverlayContentUuid(contentUuid));
  }
});


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PdfSection);
